"use client"

import { useInView } from "@/hooks/use-in-view"
import { cn } from "@/lib/utils"

export function About() {
  const { ref: titleRef, isInView: titleInView } =
    useInView<HTMLHeadingElement>()

  return (
    <section id="nosotros" className="py-16 lg:py-24 bg-background-about">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid lg:grid-cols-1 items-center">
          {/* Content */}
          <div>
            <h2
              ref={titleRef}
              className={cn(
                "mt-4 font-work text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-titulo-hero leading-tight text-center transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              Transformamos la complejidad en simplicidad
            </h2>
            <p
              className={cn(
                "font-jetbrains font-extralight mt-6 text-lg text-titulo-hero/60 leading-relaxed transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              En Hercode creemos que cada empresa trabaja de una manera única, y por eso sus herramientas también deberían serlo. En lugar de ofrecer software genérico, creamos aplicaciones web a medida que se adaptan naturalmente a la forma en que tu equipo ya trabaja.
            </p>
            <p
              className={cn(
                "font-jetbrains font-extralight mt-4 text-lg text-titulo-hero/60 leading-relaxed transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              Nuestro proceso comienza escuchando y entendiendo cómo funcionan hoy tus operaciones. A partir de ese análisis, identificamos oportunidades para simplificar tareas, automatizar procesos y ayudarte a trabajar de forma más eficiente, con soluciones pensadas realmente para tu negocio.
            </p>
            <div className="mt-8">
              <div className="relative overflow-hidden rounded-2xl">
                <img
                  src="/fondo_about1.jpg"
                  alt="Hercode"
                  className="w-full object-cover"
                />
                <div className="pointer-events-none absolute inset-0 bg-background-about/50 mix-blend-multiply" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
